<footer>
  <p>© enkei64 2025. All rights reserved.</p>
</footer>

<style>
  footer {
    text-align: center;
    padding: var(--spacing-sm) var(--spacing-lg);
    margin: var(--spacing-xl) auto;
    width: fit-content;
    border-radius: 25px;
    background: var(--glass-bg);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid var(--glass-border);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  footer:hover {
    transform: scale(1.05);
  }

  p {
    color: var(--text-secondary);
    font-size: 0.875rem;
    margin: 0;
  }
</style> 